import React from "react";

const Hotel = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-hotel"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-hotel"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M18,0H6c-1.654,0-3,1.346-3,3V24h7v-6h-3v-2h10v2h-3v6h7V3c0-1.654-1.346-3-3-3ZM9,14h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2v-2h2v2Zm4,8h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2v-2h2v2Zm4,8h-2v-2h2v2Zm0-4h-2v-2h2v2Zm0-4h-2v-2h2v2Z" />
    </svg>
  );
};

export default Hotel;
